// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2o3YA","rootSuccess":"CompleteLink_rootSuccess__2xr4X","rootFailure":"CompleteLink_rootFailure__Q0Ee_","isDisabled":"CompleteLink_isDisabled__Avt6G"};